import React, {Component} from 'react';
import {Button, Col, Container, Input, InputGroup, InputGroupAddon, InputGroupText, Row} from 'reactstrap';
import {Redirect} from "react-router-dom";

class ErrorPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: this.props.erreur,
      timeloanding: false,
    }
  }

  onLoand() {
    setTimeout(() => {
      if (this.state.error != "") {
        this.setState({
          error: "",
          timeloanding: true,
        });

      }
    }, 4000)
  }

  render() {
    return (
      <div className="app flex-row align-items-center" >
        <Container>
          <Row className="justify-content-center">

            <div className="clearfix">
              <h1 className="float-left display-5 mr-3">{this.state.error}</h1>
              <h4 className="pt-3">Oops! </h4>

              <p className="text-muted float-left"> Problème lors de chargement, Veuillez ressayer .</p>
            </div>
          </Row>
        </Container>
      </div>
    );

  }
}
 export default ErrorPage;
